import React from 'react';
import { useTheme, THEMES } from '../context/ThemeContext';
import { SunIcon, MoonIcon, SwatchIcon, SparklesIcon } from '@heroicons/react/24/outline';

export default function ThemeToggle() {
  const { theme, changeTheme } = useTheme();

  const containerClasses = {
    light: 'bg-gray-100 border-gray-200',
    dark: 'bg-slate-800 border-slate-700',
    ocean: 'bg-sky-950 border-sky-800',
    neon: 'bg-zinc-800 border-zinc-700'
  };

  const getButtonClasses = (btnTheme) => {
    const isActive = theme === btnTheme;
    
    if (isActive) {
      switch (btnTheme) {
        case THEMES.LIGHT:
          return 'bg-white text-orange-600 shadow-sm border border-gray-200/50';
        case THEMES.DARK:
          return 'bg-slate-700 text-cyan-400 shadow-sm border border-slate-600';
        case THEMES.OCEAN:
          return 'bg-cyan-700 text-white shadow-sm border border-cyan-600';
        case THEMES.NEON:
          return 'bg-purple-900 text-lime-400 shadow-sm border border-purple-800';
        default:
          return 'bg-white text-gray-900';
      }
    } else {
      switch (theme) {
        case THEMES.DARK:
          return 'text-slate-400 hover:text-white hover:bg-slate-700/40';
        case THEMES.OCEAN:
          return 'text-sky-300 hover:text-white hover:bg-sky-900/40';
        case THEMES.NEON:
          return 'text-zinc-400 hover:text-white hover:bg-zinc-700/40';
        default:
          return 'text-gray-600 hover:text-gray-900 hover:bg-gray-200/50';
      }
    }
  };

  return (
    <div className={`flex items-center gap-0.5 p-0.5 rounded-xl border transition-all duration-300 ${containerClasses[theme] || containerClasses.light}`}>
      <button
        onClick={() => changeTheme(THEMES.LIGHT)}
        title="Light SaaS Theme"
        className={`px-2 py-1.5 rounded-lg text-[11px] font-bold flex items-center gap-1 transition-all duration-200 ${getButtonClasses(THEMES.LIGHT)}`}
      >
        <SunIcon className="w-3.5 h-3.5" />
        <span>Light</span>
      </button>

      <button
        onClick={() => changeTheme(THEMES.DARK)}
        title="Dark Glassmorphism Theme"
        className={`px-2 py-1.5 rounded-lg text-[11px] font-bold flex items-center gap-1 transition-all duration-200 ${getButtonClasses(THEMES.DARK)}`}
      >
        <MoonIcon className="w-3.5 h-3.5" />
        <span>Dark</span>
      </button>

      <button
        onClick={() => changeTheme(THEMES.OCEAN)}
        title="Ocean Cyan Gym Theme"
        className={`px-2 py-1.5 rounded-lg text-[11px] font-bold flex items-center gap-1 transition-all duration-200 ${getButtonClasses(THEMES.OCEAN)}`}
      >
        <SwatchIcon className={`w-3.5 h-3.5 ${theme === THEMES.OCEAN ? 'text-white' : 'text-cyan-500'}`} />
        <span>Ocean</span>
      </button>

      <button
        onClick={() => changeTheme(THEMES.NEON)}
        title="Neon Power Gym Theme"
        className={`px-2 py-1.5 rounded-lg text-[11px] font-bold flex items-center gap-1 transition-all duration-200 ${getButtonClasses(THEMES.NEON)}`}
      >
        <SparklesIcon className={`w-3.5 h-3.5 ${theme === THEMES.NEON ? 'text-lime-400' : 'text-lime-500'}`} />
        <span>Neon</span>
      </button>
    </div>
  );
}
